export default {
  title: 'Shop-domæne',
  description:
    'Server dine restauranters onlineshops på et domæne, du selv ejer, i stedet for den delte adresse – for eksempel pizza-mario.order-yourbrand.com. Du tilføjer to DNS-poster én gang; hver restaurant, du tilføjer senere, får automatisk sin adresse.',
  read_only_description:
    'Det domæne, som denne partners restaurantshops serveres under. Kun partneren kan forbinde eller ændre det.',
  read_only_empty: 'Denne partner har ikke forbundet et shop-domæne.',
  not_connected: {
    label: 'Domæne til dine restauranters shops',
    hint: 'Et domæne eller subdomæne, du ejer, f.eks. order-yourbrand.com. Det skal være et andet domæne end det, dit teams apps kører på – ikke et subdomæne af det.',
    placeholder: 'order-yourbrand.com',
    connect: 'Forbind',
  },
  status: {
    pending_dns: 'Venter på DNS',
    active: 'Live',
    failed: 'Handling påkrævet',
    disabled: 'Frakoblet',
  },
  primary_badge: 'Primær',
  summary: {
    pending: 'Vi venter på dine DNS-records. Det tager som regel et par minutter, men kan tage flere timer.',
    failed:
      'Vi kunne ikke bekræfte alle records i tide. Ret den record, der er markeret nedenfor, og tryk derefter på Tjek igen – så begynder vi at tjekke forfra herfra.',
    failed_leave: 'Hvis du i stedet vil forbinde et andet domæne, skal du først frakoble dette.',
    live: '{{host}} er live.',
    primary: 'Hver ny restaurant får automatisk sin adresse under dette domæne.',
    standby:
      'Gør det primært for automatisk at give det til alle nye restauranter. Restauranter, der allerede ligger på et andet domæne, bliver, hvor de er.',
    regressed:
      '{{host}} er live, men en record nedenfor består ikke længere kontrollen. Dine shops er stadig online – ret recorden hos din DNS-udbyder.',
  },
  instructions: {
    title: 'Sådan tilføjer du recordsene',
    step_provider: 'Log ind der, hvor DNS for {{root}} administreres – som regel hos det firma, du købte domænet af.',
    step_add: 'Tilføj hver record nedenfor præcis som vist: type, navn og værdi.',
    step_check: 'Gem, og klik derefter på “{{button}}”. Vi fortsætter også selv med at tjekke.',
    tip_name:
      'De fleste udbydere vil kun have den del før {{root}} i navnefeltet – _foodamigos-verify og *. Det fulde navn vises nedenunder til udbydere, der kræver det.',
    tip_wildcard:
      '*-recorden sender alle adresser under {{root}} til dine shops, så du aldrig skal tilføje en record pr. restaurant.',
    tip_existing:
      'Eksisterende records for {{root}}, f.eks. din hjemmeside, mail eller www, virker fortsat: *-recorden besvarer kun navne, der ikke har en egen record. Hvis {{root}} allerede har en *-record, skal du erstatte den med vores.',
    tip_cloudflare: 'Hos Cloudflare skal CNAME-recorden sættes til kun DNS (grå sky), ellers kan vi ikke se den.',
  },
  records: {
    title: 'Tilføj disse DNS-records for {{root}} hos din domæneudbyder',
  },
  example: 'En restaurant får så en adresse som {{host}}.',
  example_label: 'din-restaurant',
  buttons: {
    check_again: 'Tjek igen',
    make_primary: 'Gør primær',
    unlink: 'Frakobl',
    retry: 'Prøv igen',
  },
  primary_unavailable: 'Tilgængelig, når domænet er live.',
  unlink_blocked_one:
    '{{count}} restaurant ligger stadig på dette domæne. Flyt den til et andet domæne, før du frakobler.',
  unlink_blocked_other:
    '{{count}} restauranter ligger stadig på dette domæne. Flyt dem til et andet domæne, før du frakobler.',
  unlink_confirm: {
    title: 'Frakobl {{host}}?',
    description: 'Du kan forbinde {{host}} igen senere.',
    description_primary:
      'Nye restauranter får igen en adresse på det fælles domæne. Du kan forbinde {{host}} igen senere.',
    ok: 'Frakobl',
  },
  toasts: {
    load_error: 'Din shop-domæne kunne ikke indlæses',
    load_error_read_only: 'Denne partners shop-domæne kunne ikke indlæses',
    connected: 'Domæne forbundet – tilføj nu recordsene nedenfor',
    connect_failed: 'Domænet kunne ikke forbindes',
    check_started: 'Tjekker igen…',
    check_failed: 'Tjekket kunne ikke startes. Prøv igen om et øjeblik.',
    primary_set: 'Nye restauranter får nu dette domæne',
    primary_failed: 'Domænet kunne ikke gøres primært',
    unlinked: 'Domæne frakoblet',
    unlink_failed: 'Domænet kunne ikke frakobles',
    unlink_has_restaurants_one:
      '{{count}} restaurant ligger stadig på {{host}}: {{names}}. Flyt den til et andet domæne, før du frakobler.',
    unlink_has_restaurants_other:
      '{{count}} restauranter ligger stadig på {{host}}: {{names}}. Flyt dem til et andet domæne, før du frakobler.',
    gone: '{{host}} er ikke længere forbundet – det er måske blevet frakoblet i en anden fane.',
  },
};
